// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__SZn-Q","fileBtn":"File_fileBtn__1zZk5","closeBtn":"File_closeBtn__2pNMN","fileSelected":"File_fileSelected__3raYB","disabled":"File_disabled__3KsRU"};